export const SPA_SOFT_PHONE_TYPES = {
  5: 'MOBILEPHONE',
  6: 'HOMEPHONE',
  7: 'BUSINESSPHONE'
}
export const SPA_SOFT_GENDERS = {
  1: 'MALE',
  2: 'FEMALE'
}

export const ENHANCEMENT_USER_INPUTS = {
  EARLY_CHECK_IN: 'Selects preferred time Early Check-in',
  LATE_CHECK_OUT: 'Selects preferred time Late Check-Out',
  CELEBRATORY_TREAT: 'Celebratory Treat',
  NO_INPUT: 'No input'
}
